import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlay = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12ZM14.7864 10.304C15.6862 10.8664 16.1362 11.1476 16.2904 11.5076C16.4252 11.822 16.4252 12.178 16.2904 12.4924C16.1362 12.8524 15.6862 13.1336 14.7864 13.696L12.56 15.0875C11.5613 15.7117 11.0619 16.0238 10.6498 15.9907C10.2906 15.9618 9.96136 15.7793 9.7465 15.49C9.5 15.1581 9.5 14.5692 9.5 13.3915V10.6085C9.5 9.43076 9.5 8.84189 9.7465 8.51C9.96136 8.2207 10.2906 8.03821 10.6498 8.00933C11.0619 7.9762 11.5613 8.2883 12.56 8.9125L14.7864 10.304Z",
		fill: "#EFEEF0"
	})
});
export default SvgPlay;
